import Link from 'components/Globals/Base/Link';
import Checkmark from 'components/Globals/CheckMark';
import getCompanyPageTestId from 'constants/testsIds/companyPage';
import { Name, Rank, Wrapper, Line } from './CompanyRankStyles';

export interface CompanyRankProps {
  name: string;
  rank: string | number;
  slug: string;
  active?: boolean;
  hasOpacity?: boolean;
  classModifier?: string;
  dataCy?: string;
}

const RankingItem = ({ name, rank, slug, active, classModifier = '', hasOpacity = true, dataCy }: CompanyRankProps) => {
  const isFullPath = slug.startsWith('/company/');
  const href = isFullPath ? slug : `/company/${slug}/`;

  return (
    <Wrapper
      data-cy={dataCy}
      className={`${classModifier}`}
    >
      {!active ? (
        <Link
          className={`ranking-link ${hasOpacity ? '' : 'no-opacity'}`}
          type='white'
          dataCy={getCompanyPageTestId('FORTUNE_RANKINGS_COMPANY_RANK')}
          href={href}
          aria-label={`View ${name}'s ranking`}
        >
          <Rank
            className={classModifier}
            data-cy={`${getCompanyPageTestId('COMPANY_RANK')}-${rank}`}
          >
            {rank || <Checkmark />}
          </Rank>
          <Name
            className={`${classModifier}`}
            data-cy={`${getCompanyPageTestId('COMPANY_RANK_NAME')}-${rank}`}
          >
            {name}
          </Name>
        </Link>
      ) : (
        <Line data-cy={getCompanyPageTestId('FORTUNE_RANKINGS_COMPANY_RANK')}>
          <Rank
            className={classModifier}
            data-cy={`${getCompanyPageTestId('COMPANY_RANK')}-${rank}`}
          >
            {rank || <Checkmark />}
          </Rank>
          <Name
            className={`active ${classModifier}`}
            data-cy={`${getCompanyPageTestId('COMPANY_RANK_NAME')}-${rank}`}
          >
            {name}
          </Name>
        </Line>
      )}
    </Wrapper>
  );
};

export default RankingItem;
